/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-extraneous-class */
import { post, get, del, put } from 'aws-amplify/api'
import { environment } from '../environment'
import { mapResponseForUsers } from '../helpers/map-response'
import { PermissionDefinition } from '../interfaces/definitions/permission-definition'
import { User } from '../interfaces/definitions/user.interface'

class UserServiceInstance {
  async getUsers (): Promise<User[]> {
    try {
      const res = await get({
        apiName: environment.apiName,
        path: environment.apiPaths.adminUsers
      }).response
      return await mapResponseForUsers(res)
    } catch (e) {
      console.error('here error', e)
    }
    return []
  }

  async getStepPermission (): Promise<PermissionDefinition> {
    try {
      const res = await get({
        apiName: environment.apiName,
        path: environment.apiPaths.stepPermissions
      }).response
      return res.body.json() as unknown as PermissionDefinition
    } catch (e) {
      console.error('here error', e)
      throw e
    }
  }

  async addUser (user: {
    username: string
    password: string
    role: string
    admin: boolean
  }): Promise<void> {
    try {
      await post({
        apiName: environment.apiName,
        path: environment.apiPaths.adminUsers,
        options: { body: user }
      }).response
    } catch (e) {
      console.error('here error', e)
    }
  }

  async updateUser (
    username: string,
    role: string,
    password: string,
    admin: boolean
  ): Promise<void> {
    await put({
      apiName: environment.apiName,
      path: environment.apiPaths.adminUsers,
      options: { body: { username, role, password, admin } }
    }).response
  }

  async deleteUser (id: string): Promise<string> {
    await del({
      apiName: environment.apiName,
      path: `${environment.apiPaths.adminUsers}/${id}`
    }).response
    return id
  }
}

class UserServiceSingleton {
  private static instance: UserServiceInstance

  static getInstance (): UserServiceInstance {
    if (!UserServiceSingleton.instance) {
      UserServiceSingleton.instance = new UserServiceInstance()
    }
    return UserServiceSingleton.instance
  }
}

export const userService = UserServiceSingleton.getInstance()
